import {createStore} from "vuex";
import http from '@/http/http'

const store = createStore({
    state: {
        userId: localStorage.getItem('userId') || '',
        userToken: localStorage.getItem('userToken') || '',
        user: {},
        // isLogin: false,
        headerTitleIndex: 0, // 头部标题索引
        gameRecentlyViewedPc: [], // 最近浏览游戏
    },
    // 获取
    getters: {
        isLogin(state) {
            // console.log(state)
            return state.userToken !== ''
        },
        getUserId(state) {
            if (!state.userId) {
                state.userId = localStorage.getItem('userId');
            }
            return state.userId;
        },
        getUserToken(state) {
            if (!state.userToken) {
                state.userToken = localStorage.getItem('userToken');
            }
            return state.userToken;
        },
        getUser(state) {
            // if (!state.userToken) {
            //     state.userToken = localStorage.getItem('userToken');
            // }
            return state.user;
        },
        getHeaderTitleIndex(state) {
            return state.headerTitleIndex;
        },
        getGameRecentlyViewed(state) {
            return state.gameRecentlyViewedPc;
        }
    },
    // 修改
    mutations: {
        setUserId(state, userId) {
            state.userId = userId;
            localStorage.userId = userId
        },
        setUserToken(state, token) {
            state.userToken = token;
            localStorage.userToken = token
        },
        setUser(state, user) {
            state.user = user;
        },
        setHeaderTitleIndex(state, index) {
            state.headerTitleIndex = index;
        },
        setGameRecentlyViewed(state, gameRecentlyViewed) {
            state.gameRecentlyViewedPc = gameRecentlyViewed;
        }
    },
    actions: {
        //获取用户信息
        getUserInfo(context) {
            http.post('sys/user/findByUserId').then(res => {
                if (res.code == 200) {
                    context.commit('setUser',res.data)
                }
            })
        },
    },
})
export default store